import {UCheckbox} from "components/core/uCheckbox/uCheckbox";
import {FormControl, FormField, FormItem, FormMessage} from "components/ui/form";

export function FormCheckbox({
                               control,
                               name,
                               label,
                               labelClassName,
                               ...props
                             }: {
  control: any;
  name: string;
  label: React.ReactNode;
  labelClassName?: string;
}) {
  return (
    <FormField
      control={control}
      name={name}
      render={({field}) => (
        <FormItem>
          <FormControl>
            <UCheckbox
              {...props}
              field={field}
              label={label}
              labelClassName={labelClassName}
            />
          </FormControl>
          <FormMessage className="mt-1"/>
        </FormItem>
      )}
    />
  );
}
